import { createAction } from "@reduxjs/toolkit";
import {
  attachPostsActionTypes,
  getCreateSubscriptionPostsActionTypes,
  getMoreCreateSubscriptionPostsActionTypes,
} from "./actionTypes";

export const getCreateSubscriptionPosts = createAction(
  getCreateSubscriptionPostsActionTypes.request,
);

export const getCreateSubscriptionPostsSuccess = createAction(
  getCreateSubscriptionPostsActionTypes.success,
  (payload) => ({ payload }),
);

export const getCreateSubscriptionPostsFailure = createAction(
  getCreateSubscriptionPostsActionTypes.failure,
  (payload) => ({ payload }),
);

export const getCreateSubscriptionPostsReset = createAction(
  getCreateSubscriptionPostsActionTypes.reset,
);

export const getMoreCreateSubscriptionPosts = createAction(
  getMoreCreateSubscriptionPostsActionTypes.request,
);

export const getMoreCreateSubscriptionPostsSuccess = createAction(
  getMoreCreateSubscriptionPostsActionTypes.success,
  (payload) => ({ payload }),
);

export const getMoreCreateSubscriptionPostsFailure = createAction(
  getMoreCreateSubscriptionPostsActionTypes.failure,
  (payload) => ({ payload }),
);

export const attachPostsToSubscription = createAction(
  attachPostsActionTypes.request,
  (payload) => ({ payload }),
);

export const attachPostsToSubscriptionSuccess = createAction(
  attachPostsActionTypes.success,
  (payload) => ({ payload }),
);

export const attachPostsToSubscriptionFailure = createAction(
  attachPostsActionTypes.failure,
  (payload) => ({ payload }),
);
